export const appIds = {
  USER_MANAGER: 1,
  OGONE: 2,
  PASS_ACQUIRING: 3,
  DEVELOPER: 5,
  SALESFORCE_COMMUNITY: 6,
  WELCOME_PAGE: 7,
  BACK_OFFICE: 8
};
